import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'

const ProductInfoVariationSeventy = (props) => {
  const styles = useStyles()
  const { t } = props

  return (
    <Box className={styles.seventyVariantRoot}>
      <Typography variant="h4">{t(props.title)}</Typography>
      <Box className={styles.iconListContainer}>
        {props.iconList &&
          props.iconList.map((items, index) => (
            <Box className={styles.iconListItem} key={index}>
              {items.icon}
              <Typography variant="body1">{t(items.description)}</Typography>
            </Box>
          ))}
      </Box>
    </Box>
  )
}

export default ProductInfoVariationSeventy
